import React from 'react';
import {connect} from "react-redux";
import {Paper, Subheader} from 'material-ui'
import PropTypes from 'prop-types';
import styles from './AddAdminPage.css';
import style from '../../../styles/styles';
import AddAdminForm from "../../../components/admin/AddAdminForm/AddAdminForm";
import {postAdmin} from '../../../store/admins/actions'
import {getApps} from '../../../store/apps/actions'
import Loading from "../../../components/common/Loading/Loading";
import Error from "../../../components/common/Error/Error";
import withTranslation from "../../../hoc/withTranslation";

export class AddAdminPage extends React.Component {

    static propTypes = {
        admin: PropTypes.object
    };

    static defaultProps = {
        loading: true,
        admin: null
    };

    componentWillUpdate(nextProps) {
        if (nextProps.admin && !nextProps.submitting) {
            this.props.history.push(`/admin/${nextProps.admin.id}`);
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
       await this.props.postAdmin(formProps)
    };

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.submitting) {
            return <Loading paper={false} />;
        }

        return (
            <div>
                <h3 style={style.navigation}>{this.props.t('generic.admin')} / {this.props.t('generic.add')}</h3>
                <Paper style={styles.editBox}>
                    <Subheader
                        style={style.subHeader}>{this.props.t('account_page.new_admin')}</Subheader>
                    <div style={style.paper}>
                        <AddAdminForm
                            apps={this.props.apps}
                            onSubmit={this.handleFormSubmit}
                            submitting={this.props.submitting} />
                    </div>
                    <div style={style.clear} />
                </Paper>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        adminError: state.admins.error,
        submitting: state.admins.sending,
        admin: state.admins.currentAdmin,
        apps: state.apps.content,
    };
}

export default connect(mapStateToProps, {
    postAdmin,
    getApps
})(withTranslation(AddAdminPage));



// WEBPACK FOOTER //
// src/containers/admin/AddAdminPage/AddAdminPage.js